<div class="layout-container">
  <!-- Header fixo fora do sidenav-container -->
  <app-header (toggleSidebar)="toggleSidebar()"></app-header>

  <!-- Sidenav Container com sidebar e conteúdo principal -->
  <mat-sidenav-container class="sidenav-container">
    <!-- Sidebar -->
    <mat-sidenav
      #sidenav
      [mode]="isMobile ? 'over' : 'side'"
      [(opened)]="isSideBarOpen"
    >
      <app-sidebar [username]="username"></app-sidebar>
    </mat-sidenav>

    <!-- Conteúdo principal -->
    <mat-sidenav-content class="content-wrapper">
      <div class="main-content">
        <router-outlet></router-outlet> <!-- Conteúdo das páginas -->
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>